import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get Tables List (Admin)
export const getTablesList = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  try {
    const res = await api.get("/user/get-tables-list", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
        ...params,
      },
    });

    return res.data; 
    // { data: [...tables], message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Create Tables (Admin)
export const createTables = async ({ tables_number }) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("tables_number", String(tables_number || 0));

  try {
    const res = await api.post("/admin/create-tables", formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; 
    // { data: [...tables], message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Hide Tables (Admin)
export const hideTables = async ({ tables_number }) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("tables_number", String(tables_number || 0));

  try {
    const res = await api.post("/admin/hide-tables", formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; 
    // { data: [], message: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Show Hidden Tables (Admin)
export const showHiddenTables = async ({ tables_number }) => {
  const headers = {
    ...getAuthHeaders(), // ✅ Bearer token
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("tables_number", String(tables_number || 0));

  try {
    const res = await api.post("/admin/show-hiden-tables", formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data; 
    // { data: [...tables], message?: "..." }
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Change Tables QR Code
export const changeTablesQrCode = async (fromTableId, toTableId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  const formData = new FormData();
  formData.append("from_table_id", fromTableId);
  formData.append("to_table_id", toTableId);

  try {
    const res = await api.post(
      "/admin/change-tables-qr-code",
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        data: {
          from_table: {...},
          to_table: {...}
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};